// extracted by mini-css-extract-plugin
export default {"tooltip":"Io-z","sharingV2":"Jo-z","sharingIconsV2":"Ko-z","links":"Lo-z","link":"Mo-z","facebookV2":"No-z","twitterV2":"Oo-z","pinterestV2":"Po-z"};